import React from 'react'
import { useState, useCallback } from 'sb-hooks'

import { Row, Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import { UpchargePrice } from 'components/_new/ui'

import messages from './messages'
import s from './UpchargePriceInfo.scss'


type UpchargePriceInfoProps = {
  upchargePrice: number
}

const UpchargePriceInfo: React.FunctionComponent<UpchargePriceInfoProps> = ({ upchargePrice }) => {
  const [ isShow, setShowStatus ] = useState(false)

  const createToggleHandler = useCallback((status: boolean) => () => {
    setShowStatus(status)
  }, [])

  return (
    <Box relative>
      <Row justify="start" align="center">
        <UpchargePrice price={upchargePrice} size="sm" />
        <Box ml={8}>
          <Text
            className={s.icon}
            message="?"
            size="16-24"
            color="brand"
            align="center"
            semibold
            onClick={createToggleHandler(true)}
          />
        </Box>
        {
          isShow && (
            <Box className={s.textContainer} p={24}>
              <CloseIcon
                className={s.closeIcon}
                onClick={createToggleHandler(false)}
              />
              <Text message={messages.text} size="12-16" />
            </Box>
          )
        }
      </Row>
    </Box>
  )
}


export default UpchargePriceInfo
